import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO + Open Graph + Twitter card head tags.
 */
export const SeoHead = ({
    title,
    description,
    path = "/",
    image = "/og-image.png",
}) => {
    const siteUrl =
        typeof window !== "undefined"
            ? window.location.origin
            : "https://vibeforsuccess.org";
    const fullUrl = `${siteUrl}${path}`;
    const fullImage = image.startsWith("http") ? image : `${siteUrl}${image}`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={fullImage} />
            <meta property="og:site_name" content="Vibe for Success" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImage} />

            <meta name="theme-color" content="#1A0B3D" />
        </Helmet>
    );
};

export default SeoHead;
